import { Grid } from "@material-ui/core";
import i18next from "assets/i18n/i18n";
import React from "react";
import itsmePhone from "assets/images/png/itsmePhone.png";
import ButtonMoreInfo from "components/buttons/secondary-buttons/ButtonMoreInfo";
import { Title, Text } from "components/labels";

const WhatIsItsme = (): React.ReactElement => {
    return (
        <Grid item xs container alignContent="center" justifyContent="center" spacing={6}>
            <Grid item container xs={12} lg={4} justifyContent="center">
                <img src={itsmePhone} alt="phone handed with itsme screen" />
            </Grid>
            <Grid item xs={12} lg={4}>
                <Grid container item xs justifyContent="center">
                    <Grid item xs={11} lg={12}>
                        <Title>{i18next.t("WhatIsItsme.Header")}</Title>
                    </Grid>
                    <Grid item xs={11} lg={12}>
                        <Text>{i18next.t("LoginPage.WhatIsItsme.ItsmeInfo")}</Text>
                    </Grid>
                    <Grid item xs={11} lg={12}>
                        <Text>{i18next.t("LoginPage.WhatIsItsme.CoupleAccount")}</Text>
                    </Grid>
                    <Grid item xs={11} lg={12}>
                        <ButtonMoreInfo />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default WhatIsItsme;
